import builder from '../builder';
import KitchenKnifeSet from '../../streamline-icons/bold/kitchen-knife-set.svg';

export default builder('IconKitchenKnifeSetBold', KitchenKnifeSet);
